import { Component, OnInit, Input, OnDestroy } from '@angular/core'
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { EnvironmentDeviceMap } from 'src/app/planner/components/planner-edit/constants/EnvDeviceMap.const';
import * as _ from 'lodash';
import { ButtonVariant, IButtonProps } from "@amobee/component-library";
import { BSData, BSSettings } from "../../../../common/components/browse-and-select/BrowseAndSelectModel";
import { EnvironmentConst } from "../../planner-edit/constants/Environment.const";
import { Subscription } from "rxjs";
import { pairwise, startWith } from "rxjs/operators";

@Component({
    selector: 'devices',
    templateUrl: './devices.component.html',
    styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit, OnDestroy {

    @Input() group: string;
    @Input() formArray: FormArray;
    @Input() isNew: boolean;
    deviceTempStore: Array<any> = [];
    originalDeviceTempStore: Array<any> = [];
    devicesForEnv: BSData[] = [];
    preSelectedDevices: BSData[] = [];
    currentDevices: BSData[] = [];
    selectedDevices: BSData[] = [];
    originalDevices: BSData[] = [];
    originalDevicesForFilter: BSData[] = [];
    envList: Array<any> = [];
    envDeviceMap: Array<any> = [];
    envIdDeviceMap: Array<any> = [];
    open: boolean = false;
    selectedTableNullStateText: string = 'Select in the table above to add Devices';
    deviceControlSubscriptions: Array<Subscription> = [];
    saveButton: IButtonProps = {
        variant: ButtonVariant.PRIMARY,
        label: 'Save',
        onClick: () => {
            this.saveDevices();
        }
    };
    cancelButton: IButtonProps = {
        variant: ButtonVariant.NEUTRAL,
        label: 'Cancel',
        onClick: () => {
            this.cancel();
        }
    };
    settings: BSSettings = {
        views: [
            {
                label: 'Device Type',
                columns: [
                    {
                        header: 'Name',
                        accessor: (row: any) => {
                            return row.id
                        }
                    }
                ]
            }
        ]
    };
    ngOnInit(): void {
        if (this.deviceControl.disabled) {
            this.saveButton.disabled = true;
        }
        this.initializeMapData();
        this.checkEnvironmentChange();
    }
    ngOnDestroy(): void {
        this.deviceControlSubscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
    }
    initializeMapData() {
        _.forEach(EnvironmentConst, (value: any, key: string) => {
            this.envList.push({
                id: value.id,
                text: key
            });
        });
        _.forEach(EnvironmentDeviceMap, (value: any, key: string) => {
            this.envDeviceMap[key] = value.devices;
        });

        this.envList.forEach(value => {
            this.envIdDeviceMap[value.id] = this.envDeviceMap[value.text];
        })

        this.populateDevices(true);

    }
    checkEnvironmentChange(): void {
        this.deviceControlSubscriptions.push(
            this.environments.valueChanges.pipe(startWith(this.environments.value), pairwise())
                .subscribe(valuesArray => {
                    if (!_.isEqual(valuesArray[0], valuesArray[1])) {
                        this.populateDevices(false, valuesArray[0], valuesArray[1]);
                    }
                }));

    }
    populateDevices(isInit: boolean, oldEnvironments?: Array<number>, newEnvironments?: Array<number>) {
        this.devicesForEnv = [];
        this.deviceTempStore = [];
        this.originalDeviceTempStore = [];
        if(this.environments && this.environments.value && this.environments.value.length > 0) {
            this.environments.value.forEach(value => {
                this.originalDeviceTempStore = this.originalDeviceTempStore.concat(this.envIdDeviceMap[value]);
            })
        } else {
            this.envList.forEach(value => {
                this.originalDeviceTempStore = this.originalDeviceTempStore.concat(this.envDeviceMap[value.text]);
            });
        }
        this.originalDeviceTempStore = this.originalDeviceTempStore.filter(function (value, index, array) {
            return array.indexOf(value) == index;
        });
        this.originalDeviceTempStore.forEach(value => {
            this.devicesForEnv.push({
                id: value
            });
        });
        this.originalDevices = this.originalDevicesForFilter = this.devicesForEnv;
        if (isInit) {
            if (this.deviceControl.value && this.deviceControl.value.length > 0) {
                // Populate from saved devices
                this.deviceControl.value.forEach(value => {
                    this.currentDevices.push({
                        id: value
                    });
                });
                this.preSelectedDevices = this.selectedDevices = this.currentDevices;
            } else {
                this.selectedDevices = this.preSelectedDevices = this.currentDevices = this.devicesForEnv;
            }
        } else {
            // Add or remove devices based on adding/removing environments
            let diff;
            let isAdded, isRemoved;
            // Environments length will never be same
            if (newEnvironments.length > oldEnvironments.length) {
                // env added
                diff = _.differenceWith(newEnvironments, oldEnvironments, _.isEqual);
                isAdded = true;
            } else if (newEnvironments.length < oldEnvironments.length) {
                // env removed
                diff = _.differenceWith(oldEnvironments, newEnvironments, _.isEqual);
                isRemoved = true;
            }
            let diffDevices = [];
            diff.forEach(value => {
                diffDevices = diffDevices.concat(this.envIdDeviceMap[value]);
            })
            if (isAdded) {
                // Add devices per environments
                this.currentDevices.forEach(value => {
                    this.deviceTempStore.push(value.id);
                })
                // Get the new devices to add from current Devices and just add them
                let addDevices = _.differenceWith(diffDevices, this.deviceTempStore, _.isEqual);
                addDevices.forEach(value => {
                    this.currentDevices.push({
                        id: value
                    });
                });
            }
            if (isRemoved) {
                // Devices for new environments
                newEnvironments.forEach(value => {
                    this.deviceTempStore = this.deviceTempStore.concat(this.envIdDeviceMap[value]);
                });
                this.deviceTempStore = this.deviceTempStore.filter(function (value, index, array) {
                    return array.indexOf(value) == index;
                });
                // Removed env devices - new environment devices gives us the actual devices that can be removed
                let removeDevices = _.differenceWith(diffDevices, this.deviceTempStore, _.isEqual);

                this.currentDevices = this.currentDevices.filter(function (value) {
                    return !removeDevices.includes(value.id);
                });
            }

            this.selectedDevices = this.preSelectedDevices = this.currentDevices;
        }
        this.deviceControl.patchValue(_.map(this.selectedDevices, 'id'));
        if (!isInit && !this.deviceControl.touched) {
            this.deviceControl.markAsTouched();
        }
    }
    saveDevices() {
        this.selectedDevices = this.preSelectedDevices = this.currentDevices;
        this.deviceControl.patchValue(_.map(this.selectedDevices, 'id'));
        if (!this.deviceControl.touched) {
            this.deviceControl.markAsTouched();
        }
        this.open = false;
    }

    openSidebar() {
        if (!this.isDisabled) {
            this.open = true;
        }
    }

    cancel() {
        let selectedDeviceIds;
        if (!this.deviceControl.value || !this.deviceControl.value.length) {
            selectedDeviceIds = this.selectedDevices.map(value => value.id);
        } else {
            selectedDeviceIds = this.deviceControl.value;
        }
        this.preSelectedDevices = this.originalDevicesForFilter.filter(element => selectedDeviceIds.includes(element.id));
        this.open = false;
    }
    removeDevice(item) {
        this.selectedDevices = this.selectedDevices.filter(value => value.id !== item.id);
        this.currentDevices = this.preSelectedDevices = this.selectedDevices;
        this.deviceControl.patchValue(_.map(this.selectedDevices, 'id'));
        if (!this.deviceControl.touched) {
            this.deviceControl.markAsTouched();
        }
    }
    onDataChange(d: Array<BSData>) {
        this.currentDevices = d;
    }
    onFilterChange(f: any) {
        if (f.searchString && f.searchString.length) {
            this.originalDevices = this.originalDevicesForFilter.filter(value => (typeof value.id !== "number" && (value.id.toUpperCase() === f.searchString.toUpperCase() || value.id.toUpperCase().includes(f.searchString.toUpperCase()))))
        } else {
            this.originalDevices = this.originalDevicesForFilter;
        }
    }
    reset() {
        if (this.preSelectedDevices.length > 0) {
            this.preSelectedDevices = this.selectedDevices = [];
            this.deviceControl.patchValue([]);
        }
        if (!this.deviceControl.touched) {
            this.deviceControl.markAsTouched();
        }
    }
    get deviceControl() {
        return this.formArray.controls[this.group].get("deviceTypes") as FormControl;
    }
    get isDisabled(): boolean {
        return this.deviceControl.disabled;
    }
    get environments() {
        return this.formArray.controls[this.group].get("environments") as FormControl;
    }
}
